import { InfoIcon } from '@velasca/icons/info'
import { Popover } from '../Popover/Popover'
import { Background, Button } from './InfoButton.styles'
import type { InfoButtonProps } from './InfoButton.types'

export const InfoButton = ({
  className = '',
  text,
}: InfoButtonProps): JSX.Element => {
  return (
    <Popover className={className} message={text}>
      <Button>
        <Background>
          <InfoIcon />
        </Background>
      </Button>
    </Popover>
  )
}
